import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const salesOrderDeleteAtom = createMutationAtomFactory(
  'trade.salesOrderDelete',
  (params: { id: string; forceUnlink?: boolean }) => ({
    tradeSalesOrderDelete: {
      __args: {
        id: params.id,
        forceUnlink: params.forceUnlink ?? false,
      },
      deleted: true,
      blockingLoads: {
        id: true,
        documentNumber: true,
      },
      unlinkableLoads: {
        id: true,
        documentNumber: true,
      },
    },
  }),
);
